import { ChartLine, Gift, Globe, Infinity as InfinityIcon, Layout } from '@phosphor-icons/react';

const TILES: ReadonlyArray<{ icon: React.ReactNode; label: string }> = [
  { icon: <Globe size={24} />, label: 'Custom domain' },
  { icon: <Layout size={24} />, label: 'All templates' },
  { icon: <ChartLine size={24} />, label: 'Analytics' },
  { icon: <InfinityIcon size={24} />, label: 'Unlimited pages' },
];

export function FreeSection() {
  return (
    <section id="free" className="bg-canvas py-32">
      <div className="mx-auto max-w-container px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="mb-8 inline-flex items-center gap-2 rounded-full border border-line bg-board px-3 py-1 text-xs font-medium text-ink-muted shadow-card">
            <Gift weight="fill" size={12} className="text-ink" />
            Everything included. No plans. No limits.
          </span>
          <h2 className="mb-6 font-display text-3xl font-semibold tracking-tight text-ink md:text-5xl">
            Free, and staying that way.
          </h2>
          <p className="mx-auto mb-12 max-w-xl text-lg text-ink-muted">
            No pricing page. No paywall. No &ldquo;Pro&rdquo; tier hiding the good templates.
            Every feature below is available to every user, from day one.
          </p>

          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line shadow-card md:grid-cols-4">
            {TILES.map((tile) => (
              <div
                key={tile.label}
                className="flex flex-col items-center gap-2 bg-board p-6 text-ink"
              >
                <span className="mb-2">{tile.icon}</span>
                <span className="text-sm font-semibold">{tile.label}</span>
                <span className="text-xs text-ink-muted">Included</span>
              </div>
            ))}
          </div>

          <p className="mt-8 font-mono text-xs text-ink-faint">
            no credit card · no trial · no upsell
          </p>
        </div>
      </div>
    </section>
  );
}
